import {
  loginByPhone,
  fetchSignUpCode,
  signUp,
  fetchForgetCode,
  changePassWord,
  getUserInfo,
  saveUserInfo,
  getQrUrl,
  scanLogin,
  scanRegister,
  fetchScanCode
} from '@/api/user'
import { getToken, setToken, removeToken } from '@/util/auth'

const user = {
  state: {
    token: getToken(),
    phone: '',
    unionId: ''
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
      setToken(token)
    },
    SET_PHONE: (state, phone) => {
      state.phone = phone
    },
    SET_UNION_ID: (state, unionId) => {
      state.unionId = unionId
    }
    // SET_CODE: (state, unionId) => {
    //   state.unionId = unionId
    // }
  },

  actions: {
    // 用户名登录
    LoginByPhone({ commit }, userInfo) {
      const username = userInfo.PhoneNumber.trim()
      return new Promise((resolve, reject) => {
        loginByPhone(username, userInfo.PassWord)
          .then(res => {
            // const data = response.data
            commit('SET_TOKEN', res.Data)
            resolve(res)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    // 获取注册验证码
    FetchSignUpCode({ commit }, PhoneNumber) {
      return new Promise((resolve, reject) => {
        fetchSignUpCode(PhoneNumber)
          .then(res => {
            resolve(res)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    // 注册
    SignUp({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        signUp(userInfo)
          .then(res => {
            resolve(res)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    // 前端 登出
    FedLogOut({ commit }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '')
        removeToken()
        resolve()
      })
    },
    // 获取忘记密码验证码
    FetchForgetCode({ commit }, PhoneNumber) {
      return new Promise((resolve, reject) => {
        fetchForgetCode(PhoneNumber)
          .then(res => {
            commit('SET_PHONE', PhoneNumber)
            resolve(res)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    // 修改密码
    ChangePassWord({ commit }, data) {
      return new Promise((resolve, reject) => {
        changePassWord(data)
          .then(res => {
            resolve(res)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    // 获取个人信息
    GetUserInfo({ commit }, params) {
      return new Promise((resolve, reject) => {
        getUserInfo(params)
          .then(res => {
            resolve(res)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    // 保存个人信息
    SaveUserInfo({ commit }, params) {
      return new Promise((resolve, reject) => {
        saveUserInfo(params)
          .then(res => {
            resolve(res)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    // 获取扫码二维码值
    GetLoginQr({ commit }, notifyUrl) {
      return new Promise((resolve, reject) => {
        getQrUrl(notifyUrl)
          .then(res => {
            resolve(res)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    // 用户扫码登录,回调地址获取token
    ScanLogin({ commit }, params) {
      return new Promise((resolve, reject) => {
        scanLogin(params)
          .then(res => {
            commit('SET_TOKEN', res.Data.Token || '')
            commit('SET_UNION_ID', res.Data.UnionId || '')
            resolve(res)
          })
          .catch(error => {
            console.log(error)
            commit('SET_TOKEN', error.Data.Token || '')
            commit('SET_UNION_ID', error.Data.UnionId || '')
            reject(error)
          })
      })
    },
    // 扫码登陆后绑定手机号
    ScanRegister({ commit }, data) {
      return new Promise((resolve, reject) => {
        scanRegister(data)
          .then(res => {
            resolve(res)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    // 获取忘记密码验证码
    FetchScanCode({ commit }, PhoneNumber) {
      return new Promise((resolve, reject) => {
        fetchScanCode(PhoneNumber)
          .then(res => {
            commit('SET_PHONE', PhoneNumber)
            resolve(res)
          })
          .catch(error => {
            reject(error)
          })
      })
    }
  }
}

export default user
